import { __rest } from "tslib";
import * as React from 'react';
import { Title, TitleSizes } from '../Title';
export var PopoverHeader = function PopoverHeader(_a) {
  var children = _a.children,
      id = _a.id,
      props = __rest(_a, ["children", "id"]);

  return React.createElement(Title, Object.assign({
    headingLevel: "h6",
    size: TitleSizes.md,
    id: id
  }, props), children);
};